import { createContext, useContext, useState } from 'react';

const FechaContext = createContext();

export const FechaProviderPedidos = ({ children }) => {
  const today = new Date();

  // Restar 14 días
  const twoWeeksAgo = new Date(today);
  twoWeeksAgo.setDate(today.getDate());

  const formatDate = (date) => date.toISOString().split("T")[0];

  const [desde, setDesde] = useState(formatDate(twoWeeksAgo));
  const [hasta, setHasta] = useState(formatDate(today));

  return (
    <FechaContext.Provider value={{ desde, setDesde, hasta, setHasta }}>
      {children}
    </FechaContext.Provider>
  );
};

export const useFechas = () => {
  const context = useContext(FechaContext);
  if (!context) {
    throw new Error('useFechas debe usarse dentro de <FechaProviderPedidos>');
  }
  return context;
};
